// extracted by mini-css-extract-plugin
export default {"PageStart":"UserManagement_PageStart__4BShE","Card":"UserManagement_Card__S3J+8"};